import React from 'react'
import './footer.css'
export default function Footer(){
    return(
        <>
            <footer>
            <div className="container-fluid footer-main">
                <p><a href = "https://www.linkedin.com/in/aromal17/" target="_blank"><i class="fa fa-linkedin-square fa-lg" aria-hidden="true"></i>Aromal Benny</a> © 2023 - All Rights Reserved</p>
            </div>
            </footer>
        </>
    )
}

